const MainContentView = require("./MainContentView");
const ColumnLayoutContainer = require("./ColumnLayoutContainer");
const FullScreenContentView = require("./FullScreenContentView");
const DialogContentView = require("./DialogContentView");
const AuthenticationContentView = require("../logon/AuthenticationContentView");
const ErrorDialog = require("./ErrorDialog");
const PromptDialog = require("./PromptDialog");
const AbstractResourceController = require("./AbstractResourceController");
const postal = require("./PubSub");
const PopupMenu = require("./PopupMenu");
const MainHeader = require("./MainHeader");

/**
 * @param navManager {NavigationManager}
 * @param clientConfiguration {ClientConfiguration}
 * @constructor
 */
function RootController(navManager, clientConfiguration) {
    const self = this;

    const channel = postal.channel("RootController");
    const mainHeader = new MainHeader(clientConfiguration.isTouch());
    const delegatingControllers = [];
    const delegatingRenderingControllers = [];

    const contentViews = {
        main : new MainContentView(mainHeader, clientConfiguration),
        menu : new ColumnLayoutContainer(navManager, $("#menuContent"), "menu"),
        fullscreen : new FullScreenContentView(),
        authentication : new AuthenticationContentView(),
        dialog : new DialogContentView()
    };

    this.addContentView = function(id, contentView) {
        contentViews[id] = contentView;
    };

    let currentContentView = contentViews["authentication"];
    let preAuthMenu;

    const errorDialog = new ErrorDialog();
    const promptDialog = new PromptDialog();

    contentViews["dialog"].addView(errorDialog);
    contentViews["dialog"].addView(promptDialog);

    channel.subscribe("add-options-menu-entry", function(data, envelope) {
        const result = self.addOptionsMenuEntry(data.title, data.handler, data.weight);

        // `reply` uses a node-style callback, with error as the first arg
        // or data (for success) as the second
        envelope.reply(null, {$entry : result});
    });

    channel.subscribe("register-controller", function(data) {
        self.addController(data.controller);
    });

    this.addDelegatingController = function(controller) {
        delegatingControllers.push(controller);
        this.addController(controller);
    };

    this.addDelegatingRenderingController = function(controller) {
        delegatingRenderingControllers.push(controller);
    };

    this.addPreAuthMenu = function() {
        preAuthMenu = new PopupMenu("preAuthMenuContainer");
        contentViews["authentication"].addPreAuthMenu(preAuthMenu.getButton());
        $("#mobileResources").append(preAuthMenu.getContent());

        channel.subscribe("add-pre-auth-menu-entry", function(data, envelope) {
            const result = self.addPreAuthMenuEntry(data.title, data.handler, data.weight);

            // `reply` uses a node-style callback, with error as the first arg
            // or data (for success) as the second
            envelope.reply(null, {$entry : result});
        });
    };

    this.removeOptionsMenu = function() {
        mainHeader.setShowOptionsMenu(false);
    };

    this.addOptionsMenuEntry = function(title, clickHandler, weight) {
        return mainHeader.addOptionsMenuEntry(title, clickHandler, weight);
    };

    this.addPreAuthMenuEntry = function(title, clickHandler, weight) {
        if (preAuthMenu) {
            return preAuthMenu.addEntry(title, clickHandler, weight);
        }
    };

    /**
     *
     * @param {Controller} viewController
     */
    this.addController = function(viewController) {
        viewController.setNavManager(navManager);
        delegatingControllers.forEach(function(controller) {
            controller.addDelegateController(viewController);
        });

        delegatingRenderingControllers.forEach(function(renderingController) {
            renderingController.addDelegateRenderingController(viewController);
        });

        const views = viewController.getViews();

        for (let i = 0; i < views.length; i++) {
            const contentView = contentViews[views[i].getDisplayMode()];
            contentView.addView(views[i]);
        }

        navManager.registerController(viewController);
    };

    this.showView = function(view, state, skipHistory) {
        navManager.show(view, state, skipHistory);
    };

    this.showErrorDialog = function(message, doNotEscape, anchor, onClose) {
        errorDialog.setMessage(message, doNotEscape);

        if (doNotEscape) {
            const $link = errorDialog.getContent().find("a:not([href='#'])");
            $link.on("click", function(event) {
                event.preventDefault();
                postal.channel("Electron").publish("open-external", $link.attr("href"));
            });
        }
        errorDialog.setAnchor(anchor);
        errorDialog.setCloseCallback(onClose);
        self.showView(errorDialog, undefined, true);
    };

    this.showPromptDialog = function(title, message, options) {
        const promise = promptDialog.configure(title, message, options);
        self.showView(promptDialog, undefined, true);
        return promise;
    };

    postal.channel("Electron").subscribe("reload-resources", function() {
        CudaLaunch.models.resources.refresh();
    });

    postal.channel("Configuration").subscribe("resourceView", function() {
        console.log("View setting changed - reloading views");
        CudaLaunch.models.resources.refresh();
    });

    $(document).on("appviewchange", function(e, view) {
        let contentView;

        if (view === undefined) {
            contentView = contentViews["main"];
        } else {
            contentView = contentViews[view.getDisplayMode()];
            contentView.setView(view);
        }

        // Show/hide content views
        contentView.show();

        if (currentContentView !== contentView
                      && (currentContentView !== contentViews["main"] || contentView === contentViews["authentication"])
          && contentView !== contentViews["dialog"]) {
            if (contentView === contentViews["authentication"]) {
                Object.keys(contentViews)
                    .forEach(function(key) {
                        if (key !== "authentication") {
                            contentViews[key].hide();
                        }
                    });
            } else {
                currentContentView.hide();

                if (contentView !== contentViews["main"]) {
                    contentViews["main"].hide();
                }
            }
        }

        if (contentView !== contentViews.dialog) {
            currentContentView = contentView;
        }
    });

    $(window).on("throttledresize", function() {
        const width = Math.max($(window).width(), window.innerWidth);
        const height = window.innerHeight;

        $(".popup.scrollContent").css("max-width", width)
            .css("max-height", height - $(".resourcesHeader").outerHeight());

        Object.keys(contentViews).forEach(function(key) {
            contentViews[key].resize(width, height);
        });
    });

    $(document).on("appready", function() {
        $(window).trigger("throttledresize");
    });

    $(document).on("userauthenticated", function() {
        let firstLoad = true;

        $(document).on("resourceslistchange.tabmanagement", function(e, resources) {
            $("body").addClass("authenticated");

            const mainContentView = contentViews["main"];
            const $mcvContent = mainContentView.getContent();
            const mcvViews = mainContentView.getViews();

            const slick = $mcvContent.slick("getSlick");

            if (slick && slick.$slides) {
                $mcvContent.slick("slickFilter", ":not(.hidden-tab)");
                const $contentDiv = $(slick.$slides[slick.currentSlide]);
                const view = mcvViews[$contentDiv.attr("data-view-id")];

                if (firstLoad) {
                    firstLoad = false;

                    const history = navManager.getHistory();

                    if (history.last().getDisplayMode() === "authentication") {
                        const favs = {};
                        delegatingControllers.forEach(function(delegateController) {
                            if (delegateController instanceof AbstractResourceController) {
                                $.extend(favs, delegateController.filterResources(resources));
                            }
                        });

                        if (slick.$slides.length > 1 && Object.keys(favs).length === 0) {
                            const viewIndex = $(slick.$slides[1]).attr("data-view-id") || 0;
                            self.showView(mcvViews[viewIndex]);
                        } else {
                            self.showView(mcvViews[0]);
                        }
                    }
                } else {
                    const currentView = mainContentView.getCurrentView();

                    if (currentView
                        && currentView !== view
                        && CudaLaunch.serverConfiguration
                        && CudaLaunch.serverConfiguration.getSession()) {
                        self.showView(view);
                    }
                }
            }
        });
    });

    $(document).on("userunauthenticated", function() {
        $("body").removeClass("authenticated");
        $(document).off("resourceslistchange.tabmanagement");
    });
}

module.exports = RootController;


//////////////////
// WEBPACK FOOTER
// ./common/RootController.js
// module id = 2
// module chunks = 3 4